<app-data-table mainTitle="Cadastro Participante"
            singleTitle="Participante"
            routerPath="/cad-participante"
            entityPath="/cadparticipante"
            keyField="id"
            [entity]="cadParticipante"
            [columns]="this['columns']"
            [controls]="this['controls']">
</app-data-table>
